import { useEffect, useState } from "react";
import DashLayout from "@/components/DashLayout";
import api from "@/lib/api";
import { BookOpen, Sparkles } from "lucide-react";

/**
 * Learn — Coming Soon placeholder. Gated by the global feature-flag
 * `feature_flags.learn` — when an admin flips it on, this page will be
 * replaced by the full library implementation.
 */
export default function Learn() {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    api.get("/feature-flags")
      .then((r) => setEnabled(!!r.data?.learn))
      .catch(() => setEnabled(false));
  }, []);

  return (
    <DashLayout>
      <div className="max-w-3xl mx-auto p-6" data-testid="learn-page">
        <div className="fl-label text-[color:var(--fl-orange)] flex items-center gap-2">
          <BookOpen size={12} /> Learn
        </div>
        <h1 className="fl-heading text-3xl md:text-4xl mt-2" data-testid="learn-heading">
          Evidence-based reads, curated for you
        </h1>

        <div
          className="fl-card fl-card-elevated p-10 mt-8 text-center"
          data-testid="learn-coming-soon"
          style={{ borderColor: "color-mix(in oklab, var(--fl-orange) 40%, transparent)" }}
        >
          <Sparkles className="mx-auto text-[color:var(--fl-orange)]" size={28} />
          <div className="fl-heading text-xl mt-4">Coming soon</div>
          <p className="text-sm mt-3" style={{ color: "var(--fl-muted)" }}>
            Short, evidence-based reads matched to your programme, goal and injury phase — built with our clinicians.
            {enabled === true && " Content is now live — check back after a refresh."}
          </p>
          <div className="text-[11px] mt-4" style={{ color: "var(--fl-muted-2)" }}>
            We'll announce it inside your dashboard the moment it opens.
          </div>
        </div>
      </div>
    </DashLayout>
  );
}
